import { render, staticRenderFns } from "./LoginBusinessBill.vue?vue&type=template&id=136e3237&scoped=true&"
import script from "./LoginBusinessBill.vue?vue&type=script&lang=js&"
export * from "./LoginBusinessBill.vue?vue&type=script&lang=js&"
import style0 from "./LoginBusinessBill.vue?vue&type=style&index=0&id=136e3237&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e3237",
  null
  
)

export default component.exports